export default [{
	titulo: 'Condições',
	icone: 'menu-icon fa fa-caret-right',
	url: '/admin/condicoes',
	visualizar: false,
	actions: [{
		value: false,
		name: 'Cadastrar'
	}, {
		value: false,
		name: 'Editar'
	}, {
		value: false,
		name: 'Apagar'
	}]
}]